import React from "react";
import ModalBase from "./ModalBase";
import { LoadingButton } from "@mui/lab";
import { LuSave, LuXCircle } from "react-icons/lu";
import { Box, Button } from "@mui/material";

interface IModalForm {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onReset?: () => void;
  children: React.ReactNode;
  formTitle?: string;
  formWidth?: string;
  title?: string;
  isEdit?: boolean;
  loading?: boolean;
}

function ModalForm({
  children,
  formTitle,
  title,
  formWidth,
  isEdit,
  loading,
  open,
  onClose,
  onSubmit,
}: IModalForm) {
  return (
    <ModalBase
      width={formWidth || "600px"}
      title={title || `${isEdit ? "Chỉnh sửa" : "Thêm"} ${formTitle}`}
      open={open}
      handleClose={onClose}
      actions={[
        <LoadingButton
          key={1}
          loading={loading}
          variant="contained"
          size="small"
          startIcon={<LuSave size={16} />}
          sx={{
            boxShadow: "none",
            textTransform: "none",
            color: "common.white",
            "&:hover": { boxShadow: "none" },
          }}
          onClick={onSubmit}
        >
          Lưu
        </LoadingButton>,
        <Button
          key={2}
          onClick={onClose}
          variant="contained"
          size="small"
          color="error"
          startIcon={<LuXCircle size={16} />}
          sx={{
            boxShadow: "none",
            textTransform: "none",
            color: "common.white",
            "&:hover": { boxShadow: "none" },
          }}
        >
          Đóng
        </Button>,
      ]}
    >
      <Box sx={{ maxHeight: "75vh", overflow: "auto", px: 2 }}>{children}</Box>
    </ModalBase>
  );
}

export default ModalForm;
